import useLocalStorage from 'react-use-localstorage';

/** Ensures a user will only see onboarding when they first access the experience
 * by storing a boolean flag to local storage
 */
export const useOnboarding = () => {
    const [showOnboarding, setShowOnboarding] = useLocalStorage('citydna.am_onboarding', 'true')
    return [showOnboarding, setShowOnboarding] as const
}
